// Muted tones kept clear of the status colors (red, green, amber), so an avatar never reads as a
// state; all stay readable under the white initials.
const FIELD_SERVICE_COLOR_PALETTE = [
  '#5F46AA', // violet
  '#2F7AAF', // steel blue
  '#AD612E', // terracotta
  '#228174', // teal
  '#6A7A3B', // olive
  '#936F27', // ochre
  '#A632BD', // purple
  '#BD3278', // pink
] as const;

const FIELD_SERVICE_AVATAR_TEXT_COLOR = '#FFFFFF';

/**
 * Assigns each id one of FIELD_SERVICE_COLOR_PALETTE's colors, with no repeats while
 * `ids.length <= FIELD_SERVICE_COLOR_PALETTE.length` (colors cycle beyond that).
 *
 * Ids are sorted before assigning so the result only depends on the input *set*, not on
 * whatever order the API happened to return it in — otherwise the same client could get
 * reshuffled colors across two fetches of the same roster.
 */
const assignFieldServiceColors = (ids: string[]): Record<string, string> => {
  const sortedIds = Array.from(new Set(ids)).sort((a, b) => a.localeCompare(b));

  return Object.fromEntries(
    sortedIds.map((id, index) => [id, FIELD_SERVICE_COLOR_PALETTE[index % FIELD_SERVICE_COLOR_PALETTE.length]]),
  );
};

const getFieldServiceInitials = (name: string): string => name.trim().slice(0, 2).toUpperCase();

export {
  assignFieldServiceColors,
  FIELD_SERVICE_AVATAR_TEXT_COLOR,
  FIELD_SERVICE_COLOR_PALETTE,
  getFieldServiceInitials,
};
